import { useEffect, useState } from 'react'
import { createScript } from '../system/util.js'
import { CANNY_BOARD_TOKEN } from '../config/index.js'
import Loader from '../components-legacy/Loader.jsx'
import { api } from '../system/api.js'

export default function Feedback() {

  const [loading, setLoading] = useState(true)

  useEffect(() => {

    let script
    api('canny/token')
      .then((res) => {
        script = createScript("https://cdn.canny.io/sdk.js", true)
        script.onload = () => {
          if (window.Canny) {
            window.Canny('render', {
              boardToken: CANNY_BOARD_TOKEN,
              basePath: "/feedback",
              ssoToken: res.userToken,
              onLoadCallback: setLoading(false),
              theme: 'light'
            })

          }
        }
      })

    return () => {
      script && document.body.removeChild(script)
      const cannyContainer = document.querySelector(".canny-board-container")
      if (cannyContainer) {
        cannyContainer.remove()
      }
    }
  }, [])

  return (
    <main className='container pad padtop'>
      {loading && <Loader />}
      <div data-canny />
    </main>
  )
}
